import React from "react";

const TipsTutorials = () => {
  return (
    <div>
      <h2>Tips and Tutorials</h2>
    </div>
  );
};

export default TipsTutorials;
